import { shopDetailPlaceHolderData } from '~/utils/placeholderData'

export default (shopUid) => {
    return useFetchWithTanstackQuery({
        queryKey: ['shopDetail', shopUid],
        queryFn: () => $fetch(`/api/center/shops/${shopUid}`),
        options: {
            placeholderData: shopDetailPlaceHolderData
        }
    })
}
